import React from 'react';
import type { IconPropsSVG } from './types';

export function Valve(props: IconPropsSVG): React.JSX.Element {
    return (
        <svg
            viewBox="0 0 480 480"
            {...props}
        >
            <g>
                <path
                    fill="currentColor"
                    d="M472,304h-80v-8c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8v8h-48v-48c0-4.418-3.582-8-8-8h-8v-24c0-4.418-3.582-8-8-8
                h-8v-16h8c4.418,0,8-3.582,8-8v-32c0-4.418-3.582-8-8-8h-8v-24h44.28c5.382-0.016,10.547,2.121,14.344,5.936l7.44,7.44
                c14.167,14.169,37.138,14.171,51.308,0.004c6.806-6.805,10.629-16.036,10.628-25.66V92.28
                c0.002-20.037-16.239-36.282-36.276-36.284c-9.625-0.001-18.855,3.822-25.66,10.628l-7.44,7.44
                c-3.797,3.815-8.962,5.952-14.344,5.936H264V56c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8v24h-52.28
                c-5.382,0.016-10.547-2.121-14.344-5.936l-7.44-7.44c-14.167-14.169-37.138-14.171-51.308-0.004
                C83.822,73.425,79.999,82.655,80,92.28v23.44c-0.002,20.037,16.239,36.282,36.276,36.284c9.625,0.001,18.855-3.822,25.66-10.628
                l7.44-7.44c3.797-3.815,8.962-5.952,14.344-5.936H216v24h-8c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h8v16h-8
                c-4.418,0-8,3.582-8,8v24h-8c-4.418,0-8,3.582-8,8v48h-48v-8c0-4.418-3.582-8-8-8H96c-4.418,0-8,3.582-8,8v8H8
                c-4.418,0-8,3.582-8,8v104c0,4.418,3.582,8,8,8h80c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-8h208v8c0,4.418,3.582,8,8,8h32
                c4.418,0,8-3.582,8-8v-8h80c4.418,0,8-3.582,8-8v-96C480,307.582,476.418,304,472,304z M88,408H16v-88h72V408z M120,416h-16V304
                h16V416z M232,64h16v16h-16V64z M163.72,112c-9.628-0.028-18.866,3.798-25.656,10.624l-7.44,7.44
                c-7.928,7.918-20.774,7.909-28.692-0.02c-3.796-3.801-5.929-8.953-5.932-14.324V92.28c0.006-11.205,9.095-20.283,20.3-20.276
                c5.372,0.003,10.523,2.137,14.324,5.932l7.44,7.44c6.79,6.826,16.028,10.652,25.656,10.624h144.56
                c9.628,0.028,18.866-3.798,25.656-10.624l7.44-7.44c7.928-7.918,20.774-7.909,28.692,0.02c3.796,3.801,5.929,8.953,5.932,14.324
                v23.44c-0.006,11.205-9.095,20.283-20.3,20.276c-5.372-0.003-10.523-2.136-14.324-5.932l-7.44-7.44
                c-6.79-6.826-16.028-10.652-25.656-10.624H163.72z M248,128v24h-16v-24H248z M216,168h48v16h-48V168z M248,200v16h-16v-16H248z
                 M216,232h48v16h-48V232z M344,400H136v-80h56c4.418,0,8-3.582,8-8v-48h80v48c0,4.418,3.582,8,8,8h56V400z M376,416h-16V304h16
                V416z M464,400h-72v-80h72V400z"
                />
            </g>
        </svg>
    );
}
